export type Image = {
	id: string;
	url: string;
	name?: string;
	width?: number;
	height?: number;
};
export type Distribution = Record<string, number>;
export type ContentType = "QUESTION_SET" | "STUDY_SET";

export interface Metadata {
	isFavorited: boolean;
	distribution: Distribution;
	permissions: string[];
}

export type FolderContentsItemsCount = {
	numTerms: number;
	numFacts: number;
	numQuestions: number;
};
